import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { DataSignal } from 's-js';
import * as cx from 'classnames';

interface PasswordEntryProps {
    value : DataSignal<string>;
    showValidation : DataSignal<boolean>;
    className? : string;
    placeholder? : string;
    autoFocus? : boolean;
}

// TH 12/15/2016 -- NOTE: This view is specifically for when users are creating a brand new password.
// Don't use this when all you need is for users to enter their current password.
export const PasswordEntry = SuperCritical(({ className, ...rest } : PasswordEntryProps) =>
    <span className={cx('password-entry', className)}>
        <PasswordInput {...rest} />
        <PasswordValidation {...rest} />
    </span>
);

let PasswordInput = SuperCritical(({ value, showValidation, placeholder, autoFocus } : PasswordEntryProps) =>
    <input type="password"
        placeholder={placeholder}
        autoFocus={autoFocus}
        value={value()}
        onChange={e => value(e.currentTarget.value)}
        onFocus={() => showValidation(true)}
        onBlur={() => showValidation(false)} />
);

const
    passHasUpper  = (pass : string) => /[A-Z]/       .test(pass),
    passHasLower  = (pass : string) => /[a-z]/       .test(pass),
    passHasNumber = (pass : string) => /[0-9]/       .test(pass),
    passHasSymbol = (pass : string) => /[^A-Za-z0-9]/.test(pass),
    passHasMinLength = (pass : string) => pass.length >= 6;

let PasswordValidation = SuperCritical(({ value, showValidation } : PasswordEntryProps) => {
    if (!showValidation()) return null;
    return (
        <div className="password-validation">
            <div className="arrow-up"></div>
            <div className="description">Make sure you have:</div>
            <div className={cx('validation-item', { 'passes-validation': passHasUpper(value()) })}>One uppercase letter</div>
            <div className={cx('validation-item', { 'passes-validation': passHasLower(value()) })}>One lowercase letter</div>
            <div className={cx('validation-item', { 'passes-validation': passHasNumber(value()) })}>One number</div>
            <div className={cx('validation-item', { 'passes-validation': passHasSymbol(value()) })}>One symbol (ex: $, # or !)</div>
            <div className={cx('validation-item', { 'passes-validation': passHasMinLength(value()) })}>At least 6 characters</div>
        </div>
    );
});


// WEBPACK FOOTER //
// ./apps/portcall/passwordentry/view.tsx